import caseData from '../../case/data/case';
export default caseData.slice(0, 2);
